import { useAppMode } from "../context/AppModeContext";
import { FlaskConical, Sparkles } from "lucide-react";

// ModeBanner — top-of-screen strip rendered by PortalShell whenever the
// current environment is NOT production. Yellow for staging, blue for demo.
// Production renders nothing → zero visual noise for paying customers.
export default function ModeBanner() {
  const { banner, mode } = useAppMode();
  if (!banner?.show) return null;

  const tone = mode === "demo"
    ? { bg: "bg-blue-100/90",   border: "border-blue-300",   text: "text-blue-900",   Icon: Sparkles }
    : { bg: "bg-amber-100/90",  border: "border-amber-300",  text: "text-amber-900",  Icon: FlaskConical };

  return (
    <div
      data-testid={`mode-banner-${mode}`}
      className={`${tone.bg} ${tone.border} ${tone.text} border-b px-6 py-2 flex items-center gap-3 text-[12.5px]`}
    >
      <tone.Icon className="w-4 h-4 shrink-0"/>
      <span className="font-semibold mono uppercase tracking-widest text-[10.5px]">
        {banner.label}
      </span>
      <span className="flex-1 truncate">{banner.message}</span>
    </div>
  );
}
